import { render } from "./FilterSelect.vue?vue&type=template&id=589a4348"
import script from "./FilterSelect.vue?vue&type=script&lang=js"
export * from "./FilterSelect.vue?vue&type=script&lang=js"

import "./FilterSelect.vue?vue&type=style&index=0&id=589a4348&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__